module.exports = require("./be-BY.js");